import React from "react";
import { Route, Switch } from "react-router";

import QuestionnaireView from "./views/QuestionnaireView";

import SurgeryBookView from "./views/SurgeryBookView";
import SurgeryDayScheduleView from "./views/SurgeryDayScheduleView";
import SurgeryPatientLabelSheetView from "./views/SurgeryPatientLabelSheetView";

class PrintRoot extends React.Component {
    public render() {
        return (
            <div className="print-root">
                <Switch>
                    <Route exact={true} path="/print/surveys/:id" component={QuestionnaireView} />
                    <Route exact={true} path="/print/surgery/book" component={SurgeryBookView} />
                    <Route exact={true} path="/print/surgery/schedule" component={SurgeryDayScheduleView} />
                    <Route exact={true} path="/print/surgery/label-sheet" component={SurgeryPatientLabelSheetView} />
                </Switch>
            </div>
        );
    }
}

export default PrintRoot;
